import { bool, func } from "prop-types";
import Modal from "@shared/v2/Modal/Modal";
import Close from "@shared/v2/Icomoon/Icons/Close";
import IconButton from "@shared/v2/IconButton";
import CheckSolidV6 from "@shared/v2/Icomoon/Icons/CheckSolidV6";
import ArrowRightSolidV6 from "@shared/v2/Icomoon/Icons/ArrowRightSolidV6";
import Button from "@shared/v2/Button/Button";

const FEATURE_LIST = [
  {
    title: "Seamless Integration",
    desc: "Initiate title orders without leaving Brivity.",
  },
  {
    title: "Exceptional Client Experience",
    desc: "Keep your agents and clients informed throughout the process.",
  },
  {
    title: "Ownership and Hospitality",
    desc: "Turn current clients into Forever Clients. Working with Blueprint means that you have ownership throughout the contract-to-close period.",
  },
];

const BlueprintAccessModal = ({ isModalOpen, onHideHandlr, onGetAccess, isBlueprintOnboarded }) => {
  return (
    <Modal
      show={isModalOpen}
      onHide={onHideHandlr}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[616px] tw-w-full tw-flex tw-flex-col !tw-p-0"
      closeButton
    >
      <Modal.Header className="tw-relative tw-p-0 tw-border-0">
        <img
          src="/assets/hand-over-doc-blueprint.png"
          alt="Blueprint Access"
          className="!tw-mt-0 tw-block tw-w-full tw-h-full tw-object-cover tw-rounded-t-[8px]"
        />
        <IconButton
          className="tw-top-[16px] tw-right-[32px] tw-absolute"
          onClick={onHideHandlr}
          aria-label="Close"
          schema="tertiary"
          data-cy="modal-close-button"
        >
          <Close />
          <span className="tw-absolute tw-w-px tw-h-px tw-p-0 tw--m-px tw-overflow-hidden tw-clip-rect-0 tw-border-0">
            Close
          </span>
        </IconButton>
      </Modal.Header>
      <Modal.Body className="tw-overflow-y-auto tw-overflow-x-hidden tw-flow-root">
        <div className="tw-p-[32px]">
          <div className="tw-text-[18px] tw-font-bold tw-leading-[24px] tw-text-gray-75 tw-flex">
            Launch transactions with YOUR title company
          </div>
          <div className="tw-pt-[16px] tw-text-[14px] tw-font-normal tw-leading-[20px] tw-text-gray-75">
            Control more of your business within the PLACE family.
            <div>Managing the transaction process just got easier!</div>
            <div className="tw-py-[16px] tw-space-y-3">
              {FEATURE_LIST.map((item, index) => (
                <div key={index} className="tw-pl-[16px] tw-flex tw-items-start">
                  <CheckSolidV6 className="tw-mt-[5px]" />
                  <div className="tw-pl-[8px]">
                    <span className="tw-font-semibold">
                      {item.title}
                      {" - "}
                    </span>
                    <span>{item.desc}</span>
                  </div>
                </div>
              ))}
            </div>
            <div className="tw-text-[14px] tw-font-normal tw-leading-[20px] tw-text-gray-75">
              Make more of every closing. Request access to get started!
            </div>
          </div>
        </div>
      </Modal.Body>
      {!isBlueprintOnboarded && (
        <Modal.Footer className="tw-flex tw-flex-row tw-justify-center tw-mb-[32px]">
          <Button size="medium" schema="primary" onClick={onGetAccess}>
            Get access
            <ArrowRightSolidV6 className="tw-ml-[5px]" />
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};
BlueprintAccessModal.propTypes = {
  isModalOpen: bool,
  onHideHandlr: func,
  onGetAccess: func,
  isBlueprintOnboarded: bool,
};

BlueprintAccessModal.defaultProps = {
  isModalOpen: false,
  onHideHandlr: () => {},
  onGetAccess: () => {},
  isBlueprintOnboarded: false,
};
export default BlueprintAccessModal;
